<template>
  <!-- 话务系统-信息登记 -->
  <div class="info-registration">
    <!-- 最大化视图 -->
    <div v-show="viewStyle == 'max'" class="need-event max-view">
      <div class="header">
        <el-tooltip effect="dark" placement="bottom" content="最小化">
          <!-- 包裹一层，将图标区域变大一些，方便点选 -->
          <div class="rt-icon" @click="() => minimize()">
            <i class="el-icon-minus"></i>
          </div>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          placement="bottom"
          content="关闭"
          v-if="callType == 'callOut' && callOutStatus == 'keyboard'"
        >
          <div class="rt-icon" @click="() => doClose()">
            <i class="el-icon-close"></i>
          </div>
        </el-tooltip>
      </div>
      <div class="top">
        <div class="left-top">
          <TelKeyboard
            v-if="callType == 'callOut' && callOutStatus == 'keyboard'"
            @doCall="doCall"
          ></TelKeyboard>
          <Calling
            v-else-if="callType == 'callOut' && callOutStatus == 'dialing'"
            :phoneNum="phoneNum"
            @cancelCall="cancelCall"
          ></Calling>
          <CallInfo v-else :callType="callType" :phoneNum="phoneNum"></CallInfo>
        </div>
        <div class="right-top">
          <CustomerInfo :phoneNum="phoneNum" @saveFinised="doClose('save')"></CustomerInfo>
        </div>
      </div>
      <CallRecords
        v-if="phoneNum"
        :phoneNum="phoneNum"
        @showOrderDetail="showOrderDetail"
      ></CallRecords>
      <!-- 工单详情的显隐逻辑由详情组件自己控制的，其显隐状态也不会通知父组件 -->
      <Orderdetail ref="orderDetailRef" :orderInfo="orderInfo"></Orderdetail>
    </div>
    <!-- 最小化视图 -->
    <div v-show="viewStyle == 'mini'" class="need-event mini-view">
      <RBDialog :needCloseIcon="false" title="当前通话">
        <div>客户电话：{{ phoneNum }}</div>
        <div>通话时长：{{ callDuration }}</div>
        <div class="btn">
          <el-button type="primary" size="small" @click="maximize()"> 返回通话页 </el-button>
        </div>
      </RBDialog>
    </div>
  </div>
</template>

<script>
import TelKeyboard from './tel-keyboard';
import Calling from './calling';
import CallInfo from './call-info';
import CustomerInfo from './customer-info';
import CallRecords from './records';
import RBDialog from './RBDialog';
import Orderdetail from '../components/order-detail';
import { operatorStatusMap } from '../common';
import { callApi } from '@/api/call-system/call-sidebar';

export default {
  name: 'InfoRegistration',
  props: {
    // 呼叫类型 callIn-呼入 callOut-呼出
    callType: {
      type: String,
      required: true,
    },
  },
  components: {
    TelKeyboard,
    Calling,
    CallInfo,
    CustomerInfo,
    CallRecords,
    RBDialog,
    Orderdetail,
  },
  data() {
    return {
      operatorStatusMap, // 坐席状态映射
      callOutStatus: 'keyboard', // 外呼时的状态 keyboard-拨号键盘 dialing-拨号中 incall-通话中
      viewStyle: 'max', // 窗口展示方式 max-最大化 mini-最小化
      phoneNum: '', // 客户号码
      orderInfo: null, // 工单信息
    };
  },
  computed: {
    /* 坐席当前的状态 */
    currOperatorStatus() {
      return this.$store.state.callSystem.operatorStatus;
    },
    /* 当前的呼叫信息 */
    callInfo() {
      return this.$store.state.callSystem.callInfo;
    },
    /* 通话时长 */
    callDuration() {
      return this.$store.getters['callSystem/callDuration'];
    },
  },
  watch: {
    callInfo: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.phoneNum = this.callInfo.phone;
        }
      },
    },
    currOperatorStatus() {
      if (this.callType == 'callOut' && this.currOperatorStatus == this.operatorStatusMap.incall) {
        this.callOutStatus = 'incall';
      }
    },
  },
  created() {
    this.viewStyle = 'max';
  },
  methods: {
    /* 最小化窗口 */
    minimize() {
      this.viewStyle = 'mini';
    },
    /* 最大化窗口 */
    maximize() {
      this.viewStyle = 'max';
    },
    /* 关闭窗口 */
    doClose(flag) {
      // 如果是保存操作，需要清空全局存储的通话信息，以免下次有新通话时界面有残留
      if (flag == 'save') {
        this.$store.commit('callSystem/RESET_CALL_INFO');
      }
      this.viewStyle = '';
      this.$emit('close');
    },
    /* 拨打电话 */
    doCall(phoneNum) {
      this.callOutStatus = 'dialing';
      this.phoneNum = phoneNum;
      callApi({ to: phoneNum });
    },
    /* 取消拨打电话 */
    cancelCall() {
      this.callOutStatus = 'keyboard';
      this.phoneNum = '';
    },
    /* 显示工单详情 */
    showOrderDetail(orderInfo) {
      this.orderInfo = orderInfo;
      this.$refs.orderDetailRef.show();
    },
  },
};
</script>

<style lang="scss" scoped>
/* 需要拦截按键的dom元素需要加上此css类 */
.need-event {
  pointer-events: auto;
}

.info-registration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .max-view {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    overflow-y: scroll;
    background-color: #fff;

    .header {
      height: 40px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;

      .rt-icon {
        cursor: pointer;
        padding: 10px;
        i {
          font-size: 20px;
          font-weight: bolder;
        }
      }
    }

    .top {
      display: flex;
      align-items: flex-start;
      margin-bottom: 10px;

      .left-top {
        width: 220px;
        margin-right: 30px;
      }

      .right-top {
        flex: 1;
      }
    }
  }

  .mini-view {
    div {
      line-height: 30px;
    }

    .btn {
      margin-top: 10px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
